module.exports = __webpack_public_path__ + "13ce825d34dd093666ff4560d3e23fc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/oracle_2024_chart.png
// module id = 1711
// module chunks = 0